import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Briefcase, Mail } from "lucide-react";

export default function Careers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 text-white flex flex-col">
      {/* Header */}
      <header className="border-b border-slate-800/60 bg-slate-900/80 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="careers-home-link">
            <img src="/maktran-mark.png" alt="Maktran Cyber logo" className="h-9 w-auto mr-3" />
            <span className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Maktran Cyber
            </span>
          </Link>
          <Link
            to="/"
            className="flex items-center text-slate-300 hover:text-white transition-colors text-sm"
            data-testid="careers-back-link"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl text-center"
          data-testid="careers-empty-state"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-slate-800/60 border border-slate-700 mb-8">
            <Briefcase className="h-9 w-9 text-blue-400" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-400 to-red-500 bg-clip-text text-transparent">
              Careers at Maktran Cyber
            </span>
          </h1>

          <p className="text-lg text-slate-300 leading-relaxed mb-3">
            We don't have any open positions right now.
          </p>
          <p className="text-slate-400 leading-relaxed mb-10">
            Opportunities will be shown here when available. We're always growing our
            team of elite security professionals, so check back soon.
          </p>

          <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-xl p-6 text-left">
            <h2 className="text-lg font-semibold mb-2 flex items-center">
              <Mail className="h-5 w-5 text-blue-400 mr-2" />
              Want to be the first to know?
            </h2>
            <p className="text-slate-400 mb-4">
              Send your resume and a note about how you'd like to contribute, and we'll
              reach out when a matching role opens up.
            </p>
            <a
              href="mailto:info@maktrancyber.com?subject=Careers%20at%20Maktran%20Cyber"
              data-testid="careers-email-cta"
              className="inline-flex items-center bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
            >
              Email us at info@maktrancyber.com
            </a>
          </div>
        </motion.div>
      </main>

      <footer className="border-t border-slate-800 py-8 text-center text-slate-500 text-sm">
        &copy; 2026 Maktran Cyber. All rights reserved.
      </footer>
    </div>
  );
}
